import axiosInstance from './client';

export const onboardingAPI = {
  getStatus: async () => {
    const response = await axiosInstance.get('/onboarding/status');
    return response.data.data;
  },

  markComplete: async () => {
    const response = await axiosInstance.post('/onboarding/mark-complete');
    return response.data;
  },

  markSkipped: async () => {
    const response = await axiosInstance.post('/onboarding/mark-skipped');
    return response.data;
  },

  updateStep: async (step: number) => {
    const response = await axiosInstance.post('/onboarding/update-step', { step });
    return response.data;
  },

  reset: async () => {
    const response = await axiosInstance.post('/onboarding/reset');
    return response.data;
  },
};
